module.exports = __webpack_public_path__ + "static/media/boxing_bell_sound_effect.05613a3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Sound/boxing_bell_sound_effect.mp3
// module id = 522
// module chunks = 0